<template>
  <div class="brand-box">
    <div class="content">
      <div class="left">
        <div class="en-title">{{ data.describe }}</div>
        <div class="cn-title">{{ data.title }}</div>
        <div v-html="cleanHtmlText(data.content)"></div>
        <!-- <div class="title">有创意、有深度、有差异化</div>
        <div class="left-content">
          山木枝以"设计，就是创造完美的品牌体验"为核心理念，基于深入的市场走访与详实的数据信息基础，对品牌进行总体的规划与设计，明确品牌发展方向和基本活动范围，创建独一无二的品牌内核，通过品牌设计由内向外进行品牌文化的输出进而达到对公众与目标消费群体深层情感激发的目的，来获取其对品牌的认同，从而建立坚实的竞争壁垒实现长期的可持续的品牌优势与竞争力。
        </div> -->
      </div>
      <div class="right">
        <img src="@/assets/business/brand_img.png" alt="" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
@import url("./index.scss");
</style>
